export default __webpack_public_path__ + "static/media/CCSType2.c0c29be1.svg";